import * as yup from 'yup';
import { personalInfoSchema } from './personalInfoSchema';
import { devicePortalSchema } from './devicePortalSchema';
import { reportSchema } from './reportSchema';
import { optOutSchema } from './optOutSchema';
import { patientMergeSchema } from "~/schemas/patientMergeSchema";
import { customLabelSchema } from "~/schemas/customLabelSchema";
const basePatientSchema = yup.object().camelCase().shape({
    id: yup.string().required().ensure(),
    primaryPhysician: yup.string().ensure(),
    dob: yup.string().required().ensure(),
    rpmConsent: yup.boolean().required(),
    cgmConsent: yup.boolean().required(),
    ccmConsent: yup.boolean().required(),
    dataConsent: yup.boolean().required(),
    practiceId: yup.string().nullable().ensure(),
});
const reviewedDaysAmountSchema = yup.object().camelCase().shape({
    count: yup.number(),
});
export const patientSchema = yup
    .object()
    .camelCase()
    .shape({
    personalInfo: personalInfoSchema,
    devicePortal: devicePortalSchema.nullable().default(null),
    lastReport: yup.array().of(reportSchema).ensure(),
    lastReviewedReport: yup.array().of(reportSchema).ensure(),
    triageComplete: yup.boolean().required(),
    billingCgmEligible: yup.string().nullable().ensure(),
    billingRpmEligible: yup.string().nullable().ensure(),
    reviewDaysAmount: reviewedDaysAmountSchema.nullable().default(null),
    rpmConsentedAt: yup.string().nullable().ensure(),
    ccmConsentedAt: yup.string().nullable().ensure(),
    dataConsentedAt: yup.string().nullable().ensure(),
    optOutCptCodes: yup.array().of(optOutSchema).ensure(),
    mergedPatients: yup.array().of(patientMergeSchema).ensure(),
    customLabels: yup.array().of(customLabelSchema).ensure(),
    followUp: yup.date().nullable(),
    nextAppointment: yup.date().nullable(),
    lastAppointment: yup.date().nullable(),
    waitingUntil: yup.date().nullable(),
    lastUploadDate: yup.date().nullable()
})
    .concat(basePatientSchema);
export const patientReportViewSchema = yup
    .object()
    .camelCase()
    .shape({
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    reportId: yup.string().required(),
})
    .concat(basePatientSchema);
